import { useTranslation } from 'react-i18next';
import { getWhatsAppUrl } from '../utils/translation';
import { JoinButton } from './WhatsAppBanner';

const WhatsAppSimpleBanner = () => {
    const { t } = useTranslation();
    const whatsAppUrl = getWhatsAppUrl();
    console.log(whatsAppUrl);

    if (!whatsAppUrl) {
        return null;
    }

    return (
        <div className="whatsapp-simple-banner">
            <div className="padding">
                <div className="wrapper">
                    <div className="content-left">
                        <h2 className="title">
                            {t('whatsappBanner.discover')}{' '}
                            <span className="exclusive">
                                {t('whatsappBanner.exclusive')}
                            </span>{' '}
                            {t('whatsappBanner.deals')}!!
                        </h2>
                        <p className="description">
                            {t('whatsappBanner.stayUpdatedWithLatestNews')}{' '}
                            {t('whatsappBanner.offersStraightToWhatsApp')}
                        </p>
                    </div>
                    <JoinButton url={whatsAppUrl} />
                </div>
            </div>
        </div>
    );
};

export default WhatsAppSimpleBanner;
